
/**
 * API-URL
 */
export let API_URL = 'https://api.energyaid.se/api';
// export let API_URL = 'https://api.energyaid.test/api';



// WEBPACK FOOTER //
// ./src/components/partials/Globals.js